// 国际化文本
export interface I18nText {
  en_us: string;
  zh_cn: string;
  i18n_name: string;
}

export type TypeName =
  | 'multi_select'
  | 'select'
  | 'description'
  | 'five_star_scoring'
  | 'questionnaire_description';

export interface Option {
  name: I18nText;
  key: string;
  description?: I18nText;
  reason_desc?: string;
  require_reason?: boolean;
}

export interface Config {
  options?: Option[];
  five_star_scoring?: {
    max_score_desc: I18nText;
    min_score_desc: I18nText;
  };
}

export interface QuestionItemType {
  type: TypeName;
  config: Config;
}

/**
 * 规则条件右值数据结构
 * 支持字符串列表形式，用于选择题和评分题的条件判断
 */
export interface RuleRightValue {
  /** 字符串列表，存储选项key或评分值 */
  string_list?: string[];
}

/**
 * 规则条件项数据结构
 * 定义了规则中的单个条件，包含左值、操作符和右值
 */
export interface RuleConditionItem {
  /** 左值，对应问题object_id */
  left?: string;
  /** 操作符，如：Equal, NotEqual, ContainsAny, NotContains等 */
  operator?: string;
  /** 右值，条件判断的目标值 */
  right?: RuleRightValue;
}

/**
 * 问题规则数据结构
 * 定义了问题的显示规则，包含逻辑表达式和条件列表
 */
export interface QuestionRule {
  /** 逻辑表达式，如："1 and 2" 表示条件1和条件2同时满足 */
  logic?: string;
  /** 条件列表，每个条件对应一个索引号（从1开始） */
  conditions?: RuleConditionItem[];
}

// 问卷题目
export interface QuestionItem {
  name: I18nText;
  description: I18nText;
  object_id: string;
  type: QuestionItemType;
  is_required: boolean;

  /** 问题规则配置，控制问题的显示条件 */
  rule?: QuestionRule | null;
}

// 问卷状态
export enum QuestionnaireState {
  ToBeSent = 1,
  Invalid = 2,
  Sent = 3,
  FeedBack = 4
}

// 问卷题目类型
export enum QuestionFormItemType {
  five_star_scoring = 'five_star_scoring',
  select = 'select',
  multi_select = 'multi_select',
  description = 'description',
  questionnaire_description = 'questionnaire_description'
}
